module.exports = {"type":"post","category":"conf","title":"Meetup Paris Monitoring #7","date":"2016-09-29T23:46:37.121Z","path":"/meetup-paris-monitoring-7","body":"<p>hello wolrd</p>\n"}


//////////////////
// WEBPACK FOOTER
// ./paris-monitoring/2016-09-29-meetup-7/index.md
// module id = 568
// module chunks = 0